import React from 'react';
import { WhoWeAreSideBySideGradient } from './WhoWeAreLayouts';
import './WhoWeAreLayouts.css';
import './WhyChoose.css';
import '../Pages/Main.css';

function WhoWeAreSection() {
  return <WhoWeAreSideBySideGradient />;
}

export default WhoWeAreSection;
